import Div from "@jumbo/shared/Div";
import { ErrorMessage, Form, Formik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Button, TextField, Typography } from "@mui/material";
import Swal from "sweetalert2";
import deepDiff from "deep-diff";
import { LoadingButton } from "@mui/lab";
import AllApis from "app/Apis/apis";
import { Axios } from "index";
import Heading from "app/pages/Component/Heading";

export default function AddEditPtd() {
  const { state, pathname } = useLocation();
  const navigate = useNavigate();
  const [isSubmitting, setSubmitting] = useState(false);
  const [headingName, setHeadingName] = useState(
    pathname.split("/").pop() == "add" ? "Add New Term Days" : "Edit Term Days"
  );

  const initialValues = {
    payment_term_days: state?.current_data?.payment_term_days
      ? state?.current_data?.payment_term_days
      : "",
  };

  const validationSchema = yup.object({
    payment_term_days: yup
      .number()
      .typeError("Payment Term Days must be a number")
      .required("Payment Term Days is required"),
  });

  const onUserSave = async (values) => {
    let response;
    try {
      setSubmitting(true);
      if (pathname.split("/").pop() === "add") {
        response = await Axios.post(AllApis.ptd.add, values);
      } else {
        response = await Axios.patch(AllApis.ptd.edit(state._id), values);
      }
      if (response?.data?.statusCode) {
        Swal.fire({
          title:
            pathname.split("/").pop() === "add"
              ? "New Payment Term Days Created"
              : "Payment Term Days Updated",
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
        });
        navigate("/dashboards/master/paymentTermDays");
      }
    } catch (error) {
      Swal.fire({
        title: error?.response?.data.message,
        icon: "error",
        timer: 1000,
        showConfirmButton: false,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Div sx={{ mt: -4 }}>
      <Heading Name={headingName} />
      <Div>
        <Formik
          validateOnChange={true}
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={onUserSave}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form noValidate autoComplete="off">
              <Div sx={{ mt: 4 }}>
                <Div
                  sx={{
                    display: "flex",
                    width: "100%",
                    flexWrap: "wrap",
                    columnGap: 5,
                    rowGap: 1,
                  }}
                >
                  <Div sx={{ width: "45%", mt: 2 }}>
                    <Typography variant="h5">Payment Term Days</Typography>
                    <TextField
                      name="payment_term_days"
                      size="small"
                      error={
                        !!(
                          touched.payment_term_days && errors.payment_term_days
                        )
                      }
                      value={values?.payment_term_days}
                      sx={{
                        width: "100%",
                        borderColor:
                          values.payment_term_days && errors.payment_term_days
                            ? "red"
                            : "",
                      }}
                      onChange={(e) =>
                        setFieldValue("payment_term_days", e.target.value)
                      }
                    />
                    <ErrorMessage
                      name="payment_term_days"
                      component={"div"}
                      style={{ color: "red" }}
                    ></ErrorMessage>
                  </Div>
                  <Div
                    sx={{
                      width: "93.5%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 3,
                      mt: 3,
                    }}
                  >
                    <Button
                      sx={{ width: "100px" }}
                      variant="outlined"
                      onClick={() => navigate("/dashboards/master/paymentTermDays")}
                    >
                      Back
                    </Button>

                    <LoadingButton
                      variant="contained"
                      type="submit"
                      sx={{ width: "100px" }}
                      loading={isSubmitting}
                    >
                      Save
                    </LoadingButton>
                  </Div>
                </Div>
              </Div>
            </Form>
          )}
        </Formik>
      </Div>
    </Div>
  );
}
